import { render, staticRenderFns } from "./ServiceCharge.vue?vue&type=template&id=05dd4c41"
import script from "./ServiceCharge.vue?vue&type=script&lang=js"
export * from "./ServiceCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports